import {useCallback, useContext, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigator} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/hooks/useNavigator';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {REVERT_TO_BASIC} from '~/common/fabric/reducers/fabricDesign/constants';
import {DowngradeModal} from '~/common/fabric/routes/EventReview/components/DowngradeModal';
import {Sections} from '../constants';

export const useDowngradeModal = () => {
  const [showDowngradeModal, setShowDowngradeModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigator({});
  const {setShowBackground} = useContext(FabricContext);

  const toggleDowngradeModal = useCallback(() => setShowDowngradeModal((prev) => !prev), []);

  const confirmDowngrade = useCallback(() => {
    setShowBackground(false);
    setTimeout(() => {
      dispatch({type: REVERT_TO_BASIC});
    }, 500);
    navigate(Sections.CARD_DESIGN);
  }, [dispatch, navigate, setShowBackground]);

  const renderDowngradeModal = showDowngradeModal ? (
    <DowngradeModal
      toggleUpsellModal={toggleDowngradeModal}
      confirmDowngrade={() => {
        confirmDowngrade();
        toggleDowngradeModal();
      }}
    />
  ) : null;

  return {
    showDowngradeModal,
    toggleDowngradeModal,
    confirmDowngrade,
    renderDowngradeModal,
  };
};
